import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import { Icon, Image, Button } from 'semantic-ui-react';
import { Popup, MenuButton, getAvatarUrl, getProfileAvatar } from '@emyw/core-lib';
import ButtonLink from '../ButtonLink';
import EnterPinForm from '../EnterPinForm';
import UpdatePinForm from '../UpdatePinForm';
import '../primitives.css';

/** Login Menu Item can be used in a semantic menu to show either a login item when there is no authenticated user, or
 * an avatar with that when clicked shows a popup of the user's profile where they can sign out or access other account settings.
 * <br /><br />
 * <hr />
 * <br />
 * <div>
 * <h4>User Shaped Object Prop</h4>
 * The component determines which behavior to exhibit based on the presence of a user shaped object.
 * <ul>
 * <li>If no user or empty user object provided, then the Login item is presented.</li>
 * <li>If a user object is provided, then it will show the avatar or name if no avatar available and when clicked,
 * present the user profile popup.</li>
 * </ul>
 * <h4>No Profile Image</h4>
 * In order to allow the client app of this library to use their own blank profile image, a default image is not included in the library.
 * Place it along with other logo images for form banners in the path specified by the REACT_APP_AUTH_CLIENT_IMAGE_PATH environment variable.
 * </div>
 */
class LoginMenuItem extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleUserPopupOpen = () => {
      // log.trace('opening');
      this.setState({
        openUserPopup: true
      });
      this.props.onOpen();
    };
    this.handleUserPopupClose = () => {
      this.setState({
        openUserPopup: false
      });
      this.props.onClose();
    };
    this.handleForgotPin = () => this.setState({
      forgotPinModalOpen: true
    });
    this.state = {
      openUserPopup: false,
      requestProfilePIN: null,
      forgotPinModalOpen: false
    };
  }
  render() {
    const {
      user,
      onSignOutClick,
      onManageAccountClick,
      onManageProfilesClick,
      onSelectProfile,
      extensionMode,
      modalMountNode,
      popupRef,
      dimmer,
      noMenuIcons
    } = this.props;
    const activeProfile = (user || {}).activeProfile || {};
    const userProfiles = orderBy((user || {}).Profiles, ['id'], ['asc']);
    const {
      openUserPopup,
      requestProfilePIN,
      forgotPinModalOpen
    } = this.state;

    // log.trace('openUserPopup:', openUserPopup, 'activeProfile.avatarUrl:', activeProfile.avatarUrl);

    let menuItem = null;
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    if (!user || isEmpty(user) || !user.activeProfile) {
      menuItem = /*#__PURE__*/React.createElement("span", null, !noMenuIcons && /*#__PURE__*/React.createElement(Icon, {
        name: "sign in"
      }), "Login");
    } else {
      menuItem = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Popup, {
        key: user.id,
        className: "enjoyLoginMenuItem userMenu",
        trigger:
        /*#__PURE__*/
        // activeProfile.avatarUrl
        //     ? <Image src={getAvatarUrl(activeProfile.avatarUrl)} avatar />
        //     : <span>{!noMenuIcons && <Icon name="sign out" />}{activeProfile.name}</span>
        React.createElement("div", {
          className: "menuAvatar"
        }, getProfileAvatar({
          profile: activeProfile,
          avatarFloat: 'left',
          iconSize: 'large'
        })),
        on: ['hover', 'click'],
        open: openUserPopup,
        onOpen: this.handleUserPopupOpen,
        onClose: this.handleUserPopupClose,
        position: "bottom right",
        mountNode: modalMountNode,
        wide: true
      }, /*#__PURE__*/React.createElement("div", {
        ref: popupRef
      }, /*#__PURE__*/React.createElement("div", {
        className: "menuBlock menuTop"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menuCol"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "".concat(user.firstName, " ").concat(user.lastName))), /*#__PURE__*/React.createElement("div", null, user.email))), /*#__PURE__*/React.createElement("div", {
        className: "profileList_menu"
      }, userProfiles.map((profile, index) => /*#__PURE__*/React.createElement(React.Fragment, {
        key: index.toString()
      }, /*#__PURE__*/React.createElement(MenuButton, {
        className: 'profileSelectable'.concat(profile.id === user.activeProfile.id ? ' selected' : ''),
        fluid: true,
        onClick: () => {
          if (!user.pin || !profile.securedByPIN) {
            if (onSelectProfile) onSelectProfile({
              profile
            });else log.warn('onSelectProfile prop required but not provided');
          } else {
            this.setState({
              requestProfilePIN: profile
            });
          }
          this.handleUserPopupClose();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "profileBadge"
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar_wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "profile_avatar_button menuButton"
      }, getProfileAvatar({
        profile,
        className: 'menu',
        avatarFloat: 'left',
        iconSize: 'large'
      }))), /*#__PURE__*/React.createElement("div", {
        className: "profile_avatar_name menuCol"
      }, /*#__PURE__*/React.createElement("strong", null, profile.name))))))), !extensionMode && user.activeProfile.id > 0 && /*#__PURE__*/React.createElement("div", {
        className: "menuButtonContainer"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "manageProfilesLink slim",
        type: "button",
        basic: true,
        compact: true,
        fluid: true,
        onClick: () => {
          this.setState({
            openUserPopup: false
          });
          if (onManageProfilesClick) onManageProfilesClick();else log.warn('onManageProfilesClick prop required but not provided');
        }
      }, "Manage Profiles")), !extensionMode && user.activeProfile.id > 0 && /*#__PURE__*/React.createElement("div", {
        className: "menuButtonContainer"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "myAccount slim",
        type: "button",
        basic: true,
        compact: true,
        fluid: true,
        onClick: () => {
          this.setState({
            openUserPopup: false
          });
          if (onManageAccountClick) onManageAccountClick();else log.warn('onManageAccountClick prop required but not provided');
        }
      }, "Account")), /*#__PURE__*/React.createElement("div", {
        className: 'menuButtonContainer'.concat(extensionMode && user.activeProfile.id > 0 ? ' selectableButton' : '')
      }, /*#__PURE__*/React.createElement(Button, {
        className: "signOut slim",
        type: "button",
        basic: true,
        compact: true,
        fluid: true,
        onClick: () => {
          this.setState({
            openUserPopup: false
          });
          if (onSignOutClick) onSignOutClick();else log.warn('onSignOutClick prop required but not provided');
        }
      }, "Sign Out")))), /*#__PURE__*/React.createElement(EnterPinForm, {
        modalMode: true,
        user: user,
        showEnterPinModal: Boolean(requestProfilePIN),
        profile: requestProfilePIN,
        mountNode: modalMountNode,
        onSuccessClose: () => {
          onSelectProfile({
            profile: requestProfilePIN
          });
          this.setState({
            requestProfilePIN: null
          });
        },
        onForgotPinClose: this.handleForgotPin,
        onFailClose: () => {
          this.setState({
            requestProfilePIN: null
          });
        },
        dimmer: dimmer
      }), /*#__PURE__*/React.createElement(UpdatePinForm, {
        open: forgotPinModalOpen,
        user: user,
        mountNode: modalMountNode,
        onExit: () => this.setState({
          forgotPinModalOpen: false
        }),
        forgotPinMode: !requestProfilePIN,
        forgotProfilePinMode: Boolean(requestProfilePIN)
      }));
    }
    return menuItem;
  }
}
LoginMenuItem.defaultProps = {
  user: null,
  dimmer: true,
  onOpen: () => null,
  onClose: () => null,
  extensionMode: false,
  modalMountNode: undefined,
  popupRef: () => null,
  noMenuIcons: false
};
export default LoginMenuItem;